<div class="overlay">
    <div class="otp">
        <div class="otp__header">
            <div class="otp__header-label">{{'otp.label' | translate}}</div>
            <button type="button" class="otp__header-close" (click)="onClickClose()" (keydown)="onClickClose()" tabindex="0">
            <img src="assets/icons/close.svg" alt="icon-close">
        </button>
        </div>
        <div class="otp__body">
            <p>{{'otp.title' | translate}} <span>{{data.msisdn | masking}} </span></p>
            <ng-otp-input [config]="{
                allowNumbersOnly: true,
                length: data.otpCount
              }" (onInputChange)="otp.set($event)"></ng-otp-input>
            <button [disabled]="isButtonActive" [class.active]="!isButtonActive" (click)="onClickSubmit()">{{'otp.submit' | translate}}</button>
        </div>
        <div class="otp__footer">
            @if(isCountdownFinished()) {
            <p>{{'otp.expiredText' | translate}}</p>
            <button (click)="resendOTP.emit()">{{'otp.request' | translate}}</button>
            }@else {
            <app-otp-countdown (isCountdownFinished)="isCountdownFinished.set($event)" />
            <span class="countdown-text">{{'otp.countdownText.p1' | translate}} <br> {{'otp.countdownText.p2' | translate}}</span>
            }
        </div>
    </div>
</div>